








import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class LoginView extends Vue {
}

